export default __webpack_public_path__ + "static/media/arrowDown.e41234bc.svg";